<template>
  <el-drawer :visible.sync="drawer" size="700px" :with-header="false">
    <div class="see-shipment-drawer">
      <div>
        <i class="el-icon-close" style="font-size:22px" @click="onClose"></i>
      </div>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="list"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
        <el-table-column prop="proName" label="产品名称" v-if="!showF" show-overflow-tooltip></el-table-column>
        <el-table-column prop="proType" label="型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="stockupState" label="备货状态" v-if="!showF">
          <template slot-scope="scope">{{scope.row.stockupState}}</template>
        </el-table-column>
        <el-table-column prop="deliverState" label="发货状态" v-if="!showF">
          <template slot-scope="scope">{{scope.row.deliverState|deliverStateFilter}}</template>
        </el-table-column>
        <el-table-column prop="count" label="数量"></el-table-column>
      </el-table>
      <el-form label-width="70px" style="padding:20px 20px 0 0;">
        <el-row :gutter="20">
          <el-col :span="18">
            <el-form-item label="快速查询：">
              <el-input v-model="nums"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0px">
              <el-button type="primary" @click="onSearch">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="title">仓储录入产品序列号</div>
      <div class="no-contet" v-if="productList.length===0">暂无产品序列号</div>
      <div v-else class="box">
        <div class="inner" v-for="(ele,index) in productList" :key="index">{{ele.serialCode}}</div>
      </div>
      <el-row class="footer">
        <el-col :span="24" style="text-align:center;">
          <el-button type="primary" @click="onExport">导出清单</el-button>
          <el-button @click="onClose">关闭</el-button>
        </el-col>
      </el-row>
    </div>
  </el-drawer>
</template>
<script>
import {
  querySerialCodeByOcbIdAndProId,
  orderDeliverSerialCodeCoe
} from '@/api/sell/sellManage'
import { downLoadFileBlob } from '@/util/tool'
export default {
  props: ['showF'],
  data() {
    return {
      drawer: false,
      productList: [],
      tempList: [],
      list: [],
      nums: ''
    }
  },
  methods: {
    onExport() {
      // 导出出库单
      if (this.productList.length !== 0) {
        orderDeliverSerialCodeCoe({
          codeUrl: this.$store.state.sellDeliverSerial,
          list: this.productList.map((m) => m.serialCode)
        }).then((res) => {
          downLoadFileBlob(this, res)
        })
      } else {
        this.$message.error('导出序列号不得为空')
      }
    },
    onSearch() {
      this.productList = this.tempList.filter(
        (ele) => ele.serialCode.indexOf(this.nums) !== -1
      )
    },
    // 查看清单初始化
    onInitial(val, id, num) {
      this.productList = []
      this.tempList = []
      if (num) {
        this.list = [val]
        let arr = []
        arr = val.proSerialNumber ? val.proSerialNumber.split(';') : []
        arr.forEach(ele => {
          this.tempList.push({ serialCode: ele })
        })
        this.productList = JSON.parse(JSON.stringify(this.tempList))
      } else {
        const params = {
          criteriaVoList: [],
          queryPageName: ''
        }
        querySerialCodeByOcbIdAndProId(id, val.proId, params).then((res) => {
          if (res.data.code === 200) {
            if (res.data.obj) {
              this.list = [res.data.obj]
              this.productList = res.data.obj.storageOutstockContentList || []
              this.tempList = res.data.obj.storageOutstockContentList || []
            }
          }
        })
      }
      this.drawer = true
    },
    // 关闭弹窗
    onClose() {
      this.drawer = false
      this.nums = ''
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  margin: 20px auto;
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .inner {
    box-sizing: border-box;
    padding: 10px 12px;
    width: 33%;
    height: 36px;
    font-size: 14px;
    color: #4e555b;
    border: 1px solid #ebeef5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.see-shipment-drawer {
  padding: 20px;
  .title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    color: rgba(78, 85, 91, 1);
  }
  .no-contet {
    margin-top: 20px;
    width: 100%;
    height: 120px;
    text-align: center;
    line-height: 120px;
    background: rgba(243, 247, 255, 1);
  }
  .footer {
    position: absolute;
    bottom: 20px;
    left: 45%;
  }
}
</style>
